// Editor feature flags. Use these to gate UI for step kinds whose runtime
// has not yet shipped on Project O `development`. Saved/loaded data still
// flows through the dispatcher so existing opcodes render read-only.

// `call` runtime is not yet registered in Project O's CPIE registry. Engine
// rejects `kind: "call"` at execute time. Authoring is gated until the
// runtime ships (tracked under A-0012.02 SPEC §2.6).
export const CALL_STEP_AUTHORING_ENABLED = false;
